import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgramService {
  public onStepDependecyChange = new Subject<string>();
  private programListReload = new Subject<void>();

  constructor() {}

  public async setStepDependency(dependencyId?: string): Promise<void> {
    this.onStepDependecyChange.next(dependencyId);
  }

  public setProgramListReload(): void {
    this.programListReload.next();
  }

  public onProgramListReload(): Observable<void> {
    return this.programListReload.asObservable();
  }
}
